// Monokrome inline-SVG-ikoner, 20×20, arver `currentColor`.
//
// Reglene fra UX_DESIGNSYSTEM.md §6: ALDRI emoji, aldri Unicode-glyfer blandet
// med SVG i samme meny. Nytt verktøy uten ikon → legg det til her først.
//
// Bygget med `createElementNS` og ikke med en SVG-streng og `innerHTML`. Det er
// litt mer kode, men da gjelder «ingen innerHTML i src/» uten unntak, og et
// unntak er nettopp det som senere blir brukt på feltdata.

const NS = 'http://www.w3.org/2000/svg';

function svg(...baner: SVGElement[]): SVGSVGElement {
  const s = document.createElementNS(NS, 'svg');
  s.setAttribute('viewBox', '0 0 20 20');
  s.setAttribute('width', '20');
  s.setAttribute('height', '20');
  s.setAttribute('fill', 'none');
  s.setAttribute('stroke', 'currentColor');
  s.setAttribute('stroke-width', '1.6');
  s.setAttribute('stroke-linecap', 'round');
  s.setAttribute('stroke-linejoin', 'round');
  // Ikonet er dekorasjon ved siden av en tekstetikett; leses det opp i tillegg,
  // hører brukeren alt to ganger.
  s.setAttribute('aria-hidden', 'true');
  s.setAttribute('focusable', 'false');
  s.classList.add('ikon');
  for (const b of baner) s.appendChild(b);
  return s;
}

function d(bane: string): SVGElement {
  const e = document.createElementNS(NS, 'path');
  e.setAttribute('d', bane);
  return e;
}

function rekt(x: number, y: number, b: number, h: number, r = 1.5): SVGElement {
  const e = document.createElementNS(NS, 'rect');
  e.setAttribute('x', String(x)); e.setAttribute('y', String(y));
  e.setAttribute('width', String(b)); e.setAttribute('height', String(h));
  e.setAttribute('rx', String(r));
  return e;
}

function sirkel(cx: number, cy: number, r: number): SVGElement {
  const e = document.createElementNS(NS, 'circle');
  e.setAttribute('cx', String(cx)); e.setAttribute('cy', String(cy)); e.setAttribute('r', String(r));
  return e;
}

export const IKONER = {
  timer: () => svg(sirkel(10, 10, 7), d('M10 6v4l2.5 2')),
  kanban: () => svg(rekt(3, 4, 4, 12), rekt(8.5, 4, 4, 8), rekt(14, 4, 3, 5)),
  sprint: () => svg(d('M3 16V5'), d('M3 5h11l-2 3 2 3H3')),
  sammendrag: () => svg(d('M3 17h14'), rekt(4, 10, 3, 5, 1), rekt(9, 6, 3, 9, 1), rekt(14, 12, 3, 3, 1)),
  person: () => svg(sirkel(10, 7, 3), d('M4 17c0-3.3 2.7-5 6-5s6 1.7 6 5')),
  pluss: () => svg(d('M10 4v12'), d('M4 10h12')),
  kryss: () => svg(d('M5 5l10 10'), d('M15 5L5 15')),
  sjekk: () => svg(d('M4 10.5l4 4 8-9')),
  avvis: () => svg(sirkel(10, 10, 7), d('M7 7l6 6'), d('M13 7l-6 6')),
  varsel: () => svg(d('M10 3l7 13H3z'), d('M10 8v3.5'), d('M10 13.6v.2')),
  info: () => svg(sirkel(10, 10, 7), d('M10 9v5'), d('M10 6.3v.2')),
  last: () => svg(d('M16 10a6 6 0 1 1-2-4.5'), d('M16 3v3h-3')),
  ut: () => svg(d('M12 4H5v12h7'), d('M14 7l3 3-3 3'), d('M17 10H9')),
  lenke: () => svg(d('M8.5 11.5a3.5 3.5 0 0 0 5 0l2-2a3.5 3.5 0 0 0-5-5l-1 1'),
    d('M11.5 8.5a3.5 3.5 0 0 0-5 0l-2 2a3.5 3.5 0 0 0 5 5l1-1')),
  vale: () => svg(d('M10 3l6 3v5c0 3.3-2.5 5.4-6 6-3.5-.6-6-2.7-6-6V6z'), d('M7.5 10l2 2 3.5-4')),
  grep: () => svg(sirkel(7.5, 5.5, 1), sirkel(12.5, 5.5, 1), sirkel(7.5, 10, 1),
    sirkel(12.5, 10, 1), sirkel(7.5, 14.5, 1), sirkel(12.5, 14.5, 1)),
  søk: () => svg(sirkel(9, 9, 5.5), d('M13 13l4 4')),
  kalender: () => svg(rekt(3, 5, 14, 12, 2), d('M3 9h14'), d('M7 3v3'), d('M13 3v3')),
  /** Inviter: person pluss. Samme kropp som `person`, så de leses som slektninger. */
  inviter: () => svg(sirkel(8, 6.5, 3), d('M2.5 17c0-3.2 2.5-5 5.5-5 .9 0 1.8.1 2.6.4'),
    d('M14.5 11.5v5'), d('M12 14h5')),
  kopier: () => svg(rekt(3, 6, 11, 11, 2),
    d('M6 6V4.5A1.5 1.5 0 0 1 7.5 3h8A1.5 1.5 0 0 1 17 4.5v8a1.5 1.5 0 0 1-1.5 1.5H14')),
} as const;

export type Ikonnavn = keyof typeof IKONER;

/** Hent et ikon. Alltid en ny node — SVG-er kan ikke deles mellom to steder. */
export function ikon(navn: Ikonnavn): SVGSVGElement {
  return IKONER[navn]();
}
